import { c as _c } from "react/compiler-runtime";
import LinkButton from '../link-button';
import type { CtaProps } from './cta.types';

// `LinkButton` is `w-fit`, so it needs centring the column's stretch default won't give it.
export const CtaLink = t0 => {
  const $ = _c(10);
  const {
    cta
  } = t0;
  if (cta.type === "link") {
    let t1;
    if ($[0] !== cta.href || $[1] !== cta.onClick || $[2] !== cta.target || $[3] !== cta.text) {
      t1 = <LinkButton href={cta.href} target={cta.target} onClick={cta.onClick} className="self-center">{cta.text}</LinkButton>;
      $[0] = cta.href;
      $[1] = cta.onClick;
      $[2] = cta.target;
      $[3] = cta.text;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  const t1 = cta.type === "submit" ? cta.form : undefined;
  let t2;
  if ($[5] !== cta.onClick || $[6] !== cta.text || $[7] !== cta.type || $[8] !== t1) {
    t2 = <LinkButton type={cta.type} onClick={cta.onClick} form={t1} className="self-center">{cta.text}</LinkButton>;
    $[5] = cta.onClick;
    $[6] = cta.text;
    $[7] = cta.type;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};